import { Logo } from "../Logo";
import { AuthWordmark } from "./AuthWordmark";
import { getAuthLogoType, getCurrentThemeName } from "../../theme";

/** Auth panel logo: NYC only on NYC theme; tenant assets when configured; WERULE wordmark otherwise. */
export function AuthLogo() {
  const themeName = getCurrentThemeName();

  if (themeName === "black") {
    return <Logo size={200} type="women-nyc-black" />;
  }

  if (getAuthLogoType() === "tenant-brand") {
    return <Logo size={200} type="tenant-brand" variant="auth" />;
  }

  return <AuthWordmark />;
}
